import { useCallback, useEffect, useRef } from "react";

const MOTION_OFF = () =>
  typeof window !== "undefined" &&
  (window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    window.matchMedia("(pointer: coarse)").matches);

// Pointer-driven tilt: writes --mx / --my (-1..1) onto the element, RAF-throttled.
export default function useTilt() {
  const ref = useRef(null);
  const raf = useRef(0);
  const off = useRef(false);

  useEffect(() => { off.current = MOTION_OFF(); }, []);

  const onMove = useCallback((e) => {
    const el = ref.current;
    if (!el || off.current) return;
    const r = el.getBoundingClientRect();
    const mx = ((e.clientX - r.left) / r.width) * 2 - 1;
    const my = ((e.clientY - r.top) / r.height) * 2 - 1;
    cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(() => {
      el.style.setProperty("--mx", mx.toFixed(3));
      el.style.setProperty("--my", my.toFixed(3));
    });
  }, []);

  const onLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    cancelAnimationFrame(raf.current);
    el.style.setProperty("--mx", "0");
    el.style.setProperty("--my", "0");
  }, []);

  return { ref, onMove, onLeave };
}
